import { Flex, H1, P } from '@dnb/eufemia';

interface props {
  type: 'kafka-config' | 'schema' | 'release';
}

function getErrorMessage(type: props['type']): string {
  switch (type) {
    case 'kafka-config': {
      return 'There was no kafka-config found for the selected environment.';
    }
    case 'schema': {
      return 'There were no schemas found for the selected version.';
    }
    case 'release': {
      return 'There was no release found for the selected environment.';
    }
  }
}

export default function EventResourceNotFoundError({ type }: props) {
  return (
    <Flex.Vertical align="center" bottom="large" top="large">
      <H1 size="x-large">No {type} found</H1>
      <P>{getErrorMessage(type)}</P>
    </Flex.Vertical>
  );
}
